import { AppData, Utils } from '@lightningjs/sdk';
import { Artwork, Base, Icon } from '@lightningjs/ui-components';
import { AppSetup } from '../../../app-setup';

export default class TwoRowThumb2 extends Base {
    [x: string]: any;
    static override _template() {
        return {
            ImageContainer: {
                Img: {},
                SelectedImg:{}
            },
            BlockItem : {
                w: (w) => w,
                h: (h) => h,
                rect:true,
                color: 0xAA222222,
                Icon: {
                    mountX:1,
                    type: Icon,
                    x: (w) => w - 10,
                    y: 10,
                    w:50,
                    h:50,
                    icon: Utils.asset('/svg/ico-block.svg'),
                },
                shader: {},
                visible: this.blockitem
            }
        }
    }

    static get __componentName() {
        return 'TwoRowThumb2';
    }

    static get tags() {
        return ['ImageContainer', { name: 'Img', path: 'ImageContainer.Img' }, { name: 'SelectedImg', path: 'ImageContainer.SelectedImg' }]
    }

    static get properties() {
        return ['imgSrc', 'selectedImgSrc', 'rowIndex']
    }

    _update() {
        this._ImageContainer.patch({
            SelectedImg: {
                w: this.finalW,
                h: this.finalH,
                type: Artwork,
                src: this._selectedImgSrc,
                alpha: 0.0000001,
                fixed: true,
            },
            Img: {
                w: this.finalW,
                h: this.finalH,
                type: Artwork,
                src: this._imgSrc,
                fixed: true,
            }
        })
    }

    override _focus() {
        this.fireAncestors('$optionsFocused', this.rowIndex, this.itemIndex)
        this._SelectedImg.alpha = 1
        this._Img.alpha = 0.0000001
        const { platform } = AppData as AppSetup;
        platform?.textToSpeach(this.title)
    }

    override _unfocus() {
        this._SelectedImg.alpha = 0.0000001
        this._Img.alpha = 1
    }

}    